// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Header_header__GbXFg {
  width: 100%;
  height: 72px;
  min-height: 72px;
  flex-shrink: 0;
  background-color: #FCFCFC;
  box-shadow: 0px 2px 12px 0px #00000014;
  display: flex;
  justify-content: center;
  align-items: center;
  position: sticky;
  top: 0;
  z-index: 1000;
}

.Header_logo__OQwMg {
  width: 136px;
  height: 32px;
}

@media (max-width: 480px) {
  .Header_header__GbXFg {
    height: 56px;
    min-height: 56px;
  }

  .Header_logo__OQwMg {
    width: 102px;
    height: 24px;
  }
}`, "",{"version":3,"sources":["webpack://./src/CheckoutPage/Header/index.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sCAAsC;EACtC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,MAAM;EACN,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,YAAY;EACd;AACF","sourcesContent":[".header {\n  width: 100%;\n  height: 72px;\n  min-height: 72px;\n  flex-shrink: 0;\n  background-color: #FCFCFC;\n  box-shadow: 0px 2px 12px 0px #00000014;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: sticky;\n  top: 0;\n  z-index: 1000;\n}\n\n.logo {\n  width: 136px;\n  height: 32px;\n}\n\n@media (max-width: 480px) {\n  .header {\n    height: 56px;\n    min-height: 56px;\n  }\n\n  .logo {\n    width: 102px;\n    height: 24px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `Header_header__GbXFg`,
	"logo": `Header_logo__OQwMg`
};
export default ___CSS_LOADER_EXPORT___;
